// Deterministic per-company badge colors so each company is easy to spot at a
// glance across the For Dispatch, Back Office Imports, and Turn-ins tables.
//
// The class strings below are written out in full (no string interpolation) so
// Tailwind's content scanner includes them in the build.

// Known companies pinned to strongly contrasting colors. Keyed by the
// (uppercased) prefix or name so they're stable and obviously distinct.
const FIXED = {
  BEST: "bg-blue-200 text-blue-900",
  ATS: "bg-orange-200 text-orange-900",
  A6: "bg-emerald-200 text-emerald-900",
};

// Fallback palette for any other company — bolder shades, ordered so adjacent
// hash buckets land on far-apart hues.
const COMPANY_PALETTE = [
  "bg-blue-200 text-blue-900",
  "bg-orange-200 text-orange-900",
  "bg-emerald-200 text-emerald-900",
  "bg-fuchsia-200 text-fuchsia-900",
  "bg-amber-200 text-amber-900",
  "bg-teal-200 text-teal-900",
  "bg-rose-200 text-rose-900",
  "bg-indigo-200 text-indigo-900",
  "bg-lime-200 text-lime-900",
  "bg-purple-200 text-purple-900",
  "bg-cyan-200 text-cyan-900",
  "bg-red-200 text-red-900",
];

const NEUTRAL = "bg-gray-100 text-gray-400";

function hashKey(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h * 31 + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

/**
 * Return a stable Tailwind "bg + text" class pair for a company, keyed by its
 * prefix/name so the same company always gets the same color everywhere.
 * Known prefixes get fixed, strongly contrasting colors; everything else falls
 * back to a deterministic palette. Neutral gray when there's no company.
 */
export function getCompanyBadgeClass(key) {
  if (!key) return NEUTRAL;
  const norm = String(key).trim().toUpperCase();
  if (FIXED[norm]) return FIXED[norm];
  return COMPANY_PALETTE[hashKey(norm) % COMPANY_PALETTE.length];
}
